export default __webpack_public_path__ + "static/financial-agreement-ii-c68e52171cb34266ed5270f7bc9d209e.pdf";